<template lang="pug">
b-container(fluid="lg")
    b-row
        b-col(tag="main", sm="12", md="8", lg="9")
            b-row.position-sticky.top-0(style="z-index: 1")
                PageHeader
            router-view(v-slot="{ Component, route }")
                transition
                    component(:is="Component", :key="route.path")

        b-col.d-none.d-md-flex(tag="aside", md="4", lg="3", v-if="!isMobile")
            .page-sidebar.py-4
                b-row
                    b-col(cols="12")
                        Feed(:data="feedData")

    #offcanvasFeed.offcanvas.offcanvas-end(
        tabindex="-1",
        :style="{ visibility: feedSidebarOpen ? 'visible' : false }",
        aria-modal="true",
        role="dialog",
        :class="{ show: feedSidebarOpen }"
    )
        button.btn-close.text-reset(
            type="button",
            @click="toggleFeedSidebar(false)",
            aria-label="Закрыть"
        )
        .offcanvas-body
            .page-sidebar.py-4
                b-row
                    b-col(cols="12")
                        Feed(:data="feedData")
    .offcanvas-backdrop.fade(
        :style="{ 'pointer-events': feedSidebarOpen ? 'all' : 'none' }",
        :class="{ show: feedSidebarOpen }",
        @click="toggleFeedSidebar(false)"
    )

    #offcanvasFilters.offcanvas.offcanvas-start(
        tabindex="-1",
        :style="{ visibility: filterSidebarOpen ? 'visible' : false }",
        aria-modal="true",
        role="dialog",
        :class="{ show: filterSidebarOpen }"
    )
        button.btn-close.text-reset(
            type="button",
            @click="toggleFilterSidebar(false)",
            aria-label="Закрыть"
        )
        .offcanvas-body
            .page-sidebar.py-4
                b-row
                    b-col(cols="12")
                        Filters(:filters="filtersData")
    .offcanvas-backdrop.fade(
        :style="{ 'pointer-events': filterSidebarOpen ? 'all' : 'none' }",
        :class="{ show: filterSidebarOpen }",
        @click="toggleFilterSidebar(false)"
    )
</template>

<script>
import { mapMutations } from "vuex";
import PageHeader from "@/components/PageHeader.vue";
import Feed from "@/components/Feed.vue";
import Filters from "@/components/Filters.vue";

export default {
    name: "ConnectionsApp",
    components: { PageHeader, Feed, Filters },
    props: {
        data: { required: true, type: Object },
    },
    data: () => ({
        timeout: null,
    }),
    computed: {
        feedData() {
            return this.$store.state.feed;
        },
        filtersData() {
            return this.$store.state.filters;
        },
        isMobile() {
            return this.$store.state.isMobile;
        },
        feedSidebarOpen() {
            return this.$store.state.feedSidebarOpen;
        },
        filterSidebarOpen() {
            return this.$store.state.filterSidebarOpen;
        },
    },
    created() {
        this.setCompanies(this.data.companies);
        this.setFeed(this.data.feed);
        this.setFilters(this.parseFilters());
    },
    mounted() {
        this.setMobile(window.innerWidth <= 769);
        window.addEventListener("resize", () => {
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.setMobile(window.innerWidth <= 769);
            }, 150);
        });
    },
    methods: {
        ...mapMutations([
            "setCompanies",
            "setFeed",
            "setFilters",
            "setMobile",
            "setFeedSidebarState",
            "setFilterSidebarState",
        ]),
        parseFilters() {
            const filters = {
                regions: { title: "Регион", colour: "#d5ebeb", items: [] },
                branches: { title: "Отрасль", colour: "#e2f2ff", items: [] },
                interactions: {
                    title: "Форма сотрудничества",
                    colour: "#fdf6db",
                    items: [],
                },
            };
            Object.keys(filters).forEach((filterType) => {
                this.data.companies.forEach((company) => {
                    if (company[filterType]) {
                        filters[filterType].items.push(
                            company[filterType].flatMap((filter) => ({
                                name: filter.name,
                                id: filter.id,
                            }))
                        );
                    }
                });

                filters[filterType].items = filters[filterType].items.flatMap((filter) => filter);

                const uniqueFilters = [];
                filters[filterType].items.forEach((item) => {
                    const i = uniqueFilters.findIndex((x) => x.title === item.name && x.id === item.id);
                    if (i <= -1) {
                        uniqueFilters.push({
                            id: item.id,
                            title: item.name,
                            occurances: 1,
                        });
                    } else {
                        const filter = uniqueFilters.find((uF) => uF.id === item.id);
                        filter.occurances += 1;
                    }
                });

                filters[filterType].items = uniqueFilters;
            });

            return filters;
        },
        toggleFeedSidebar(state = undefined) {
            if (!state) {
                this.setFeedSidebarState(!this.feedSidebarOpen);
            } else {
                this.setFeedSidebarState(state);
            }
        },
        toggleFilterSidebar(state = undefined) {
            if (!state) {
                this.setFilterSidebarState(!this.filterSidebarOpen);
            } else {
                this.setFilterSidebarState(state);
            }
        },
    },
    watch: {
        feedSidebarOpen() {
            document.body.classList.toggle("sidebar-open", this.feedSidebarOpen);
        },
        filterSidebarOpen() {
            document.body.classList.toggle("sidebar-open", this.filterSidebarOpen);
        },
    },
};
</script>
